import { getFP } from "../services/getFingerPrint";
/**
 * Generic function to talk with the api. All 4 typical methods can be used POST | PATCH | DESTROY | GET.
 *
 * @param {String} link api-link to do the call
 * @param {String} token token for the validation
 * @param {Object} data any json object
 * @param {String} method POST | PATCH | DESTROY | GET
 * @returns Backend Response | Error | null
 */
export const sendCallToAPI = async (link, token, data, method, returnFullResponse = false) => {
  method = method ? method : "GET";
  if (!link) {
    console.log("Link is missing");
    return;
  }
  if (!token) {
    console.log("Token is missing");
    return;
  }

  let parseObject = {
    method: method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      // fp: getFP(),
      // WELCHER VOLLIDIOT MACHT SO ETWAS???
      // accessToken: token,
    },
  };
  if (data && ["POST", "PATCH", "PUT", "DELETE"].includes(method)) {
    parseObject.body = JSON.stringify(data);
  }

  if (token === "notoken") {
    delete parseObject.headers.Authorization;
  }

  return await fetch(link, parseObject)
    .then((val) => {
      if (returnFullResponse) {
        return val;
      }
      return val.json();
    })
    .catch((e) => e);
};

/**
 *  Function which search a Link in the constant { BACKENDLINKS } from "./backend_links". Also add the main path to the link.
 *
 * @param {String} name the name of the calling link
 * @returns link | null
 */
export const getLink = (app, links, name) => {
  let temp = process.env.REACT_APP_BE;
  const appString = app && app.length > 2 ? `${app}/` : "";
  const BASELINK = temp + `/${appString}`;
  let link = links.find((l) => l.name === name);
  if (link) {
    return BASELINK + link.link;
  }
  return null;
};


/**
 *  Function for reording the reporting according to fav and created date
 *
 * @param {Object} fav fav reports from localstorage
 * @param {Object} reporting all reports objects from backend
 * @returns object
 */

export const reOrderReporting = (fav, reporting) => {
  
if(typeof fav === "string"){
fav =  JSON.parse(fav)
}

reporting.sort((a, b) => {
  return new Date(a.created_at) - new Date(b.created_at);
});

const sorting = new Map(fav?.map((item, index) => [item, index]));

reporting.sort((a, b) => {
  const favIndex = sorting.get(a.id);
  const reportIndex = sorting.get(b.id);

  if (favIndex !== undefined && reportIndex !== undefined) {
    return favIndex - reportIndex;
  } else if (favIndex !== undefined) {
    return -1;
  } else if (reportIndex !== undefined) {
    return 1;
  } else {
    return 0;
  }
});

return reporting
}